import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar, MapPin, Camera, X } from "lucide-react";
import { api } from "@/lib/api";

export default function EventGallery() {
  const { id } = useParams();
  const [ev, setEv] = useState(null);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    api.get(`/events/${id}`).then(r => setEv(r.data)).catch(() => setEv(false));
  }, [id]);

  if (ev === null) return <div className="container-luxe py-32 text-center text-plumSoft">Loading…</div>;
  if (ev === false) return <div className="container-luxe py-32 text-center text-plumSoft">Event not found.</div>;

  return (
    <div data-testid="event-gallery">
      <section className="section-pad container-luxe">
        <Link to="/events" className="text-sm text-plum flex items-center gap-2 mb-8"><ArrowLeft className="w-4 h-4" /> Back to events</Link>

        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-12">
          <div className="lg:col-span-8">
            <p className="overline flex items-center gap-2"><Camera className="w-3 h-3" /> {ev.is_past ? "Photo album" : "Event details"}</p>
            <h1 className="font-display text-4xl md:text-5xl text-aubergine mt-4 leading-tight">{ev.title}</h1>
            <p className="mt-5 text-plumSoft font-light leading-relaxed max-w-2xl">{ev.description}</p>
          </div>
          <div className="lg:col-span-4 space-y-2 text-sm text-plum">
            <div className="flex items-center gap-2"><Calendar className="w-4 h-4" /><span>{new Date(ev.date).toLocaleString("en-IN", { dateStyle: "long" })}</span></div>
            <div className="flex items-center gap-2"><MapPin className="w-4 h-4" /><span>{ev.location}</span></div>
            <p className="text-xs uppercase tracking-widest text-plumSoft pt-2">Chapter · {ev.chapter || "All"}</p>
          </div>
        </div>

        {/* Photo grid */}
        {ev.photos && ev.photos.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {ev.photos.map((p, i) => (
              <button
                key={i}
                data-testid={`gallery-photo-${i}`}
                onClick={() => setLightbox(p)}
                className={`block overflow-hidden rounded-2xl group ${i === 0 ? "md:col-span-2 md:row-span-2 aspect-[16/10]" : "aspect-square"}`}
              >
                <img src={p} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </button>
            ))}
          </div>
        ) : (
          <div className="text-center py-20 text-plumSoft font-light">No photos uploaded yet.</div>
        )}
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div data-testid="lightbox" onClick={() => setLightbox(null)} className="fixed inset-0 z-50 bg-aubergine/95 flex items-center justify-center p-6 backdrop-blur-md">
          <button onClick={() => setLightbox(null)} className="absolute top-6 right-6 text-ivory hover:text-champagne"><X className="w-6 h-6" /></button>
          <img src={lightbox} alt="" className="max-w-full max-h-full rounded-xl object-contain" />
        </div>
      )}
    </div>
  );
}
